import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  content: {
    padding: 15,
  },
  scroll: {
    display: 'flex',
    gap: 15,
    flex: 1,
    flexDirection: 'column',
    padding: 10,
    '&::-webkit-scrollbar': {
      width: theme.shape.scrollSize,
      height: theme.shape.scrollSize,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.scroll,
      borderRadius: theme.shape.scrollRadius,
    },
  },
  image: {
    width: '58px',
    height: '46px',
    padding: '0 0.5em',
    borderRadius: '1em',
  },
  fileName: {
    color: '#FFFFFF',
    fontFamily: 'Roboto',
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '24px',
    letterSpacing: '0.15000000596046448px',
    marginTop: 0,
    marginBottom: '0.1em',
  },
  fileSize: {
    color: '#FFFFFF',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '14px',
    letterSpacing: '0.4000000059604645px',
    marginTop: '0.1em',
  },
  fileInfo: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '21px',
    letterSpacing: '0.10000000149011612px',
    textAlign: 'left',
    color: '#FFF',
    marginBottom: '8px',
  },
  removeFile: {
    color: '#F46A6A',
    fontFamily: 'Roboto',
    fontSize: '13px',
    fontWeight: '500',
    lineHeight: '22px',
    letterSpacing: ' 0.46000000834465027px',
    textAlign: 'left',
    '&:hover': {
      cursor: 'pointer !important',
    },
  },
  fileContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: '1em 0',
  },
  imageAndInfo: {
    display: 'flex',
    flexDirection: 'row',
    minHeight: '60px',
    '& > h1': {
      margin: '0 !important',
    },
  },
  chooseButton: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    lineHeight: '24px',
    color: '#009EE2',
  },
  limitText: {
    color: '#FFF',
    margin: '0.5em 0 !important',
  },
  hoverElement: {
    '&:hover': {
      opacity: 0.7,
      cursor: 'pointer',
    },
  },
}))

export default useStyles
